<template>
  <section
    class="bg-[#1A1A1A] border-b-[11px] border-[--yellow] lg:border-b-0 xl:border-b-[11px] flex flex-col w-full items-center py-[42px]">
    <div
      class="flex flex-col gap-[17px] xl:w-[1280px] lg:flex-row lg:px-[102px] lg:gap-[4px] w-full items-center lg:justify-between xl:px-0 xl:justify-center lg:gap-[75px]">
      <h2 class="yellow font-bold text-[38px] w-[200px] leading-[115%] text-center lg:text-left">
        Faça uma simulação
      </h2>

      <div class="flex flex-col gap-[9px] w-full lg:w-fit">
        <p class="white leading-[115%] text-center text-[20px] lg:text-left">
          Informe seu saldo FGTS
        </p>

        <div class="flex flex-col gap-[8px] lg:flex-row  lg:h-[52px] w-full px-[41px] lg:px-0">
          <div class="flex flex-row items-center gap-[8px] h-[52px] bg-[--white] w-full rounded-[8px] pl-[38px] lg:w-[390px]">
            <span class="text-[25px] leading-[115%] ">R$ </span>

            <input ref="currency" id="currency" data-thousands="." data-decimal="," placeholder="Ex.: 2.000,00" type="text"
              class="text-[--black] text-[25px] leading-[115%] bg-transparent outline-none w-[200px]" />
          </div>
          <button class=" rounded-lg !bg-[--yellow] p-[11px] text-[25px] leading-[115%] white"
            @click.prevent="send(tagText, phone)" type="button">
            Simular
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { useWhatsappUrl } from "@/composables/useWhatsappUrl";
import { trackTiktokEvent } from "@/composables/useTiktokEvent";
export default {
  name: "QuotationComponent",
  setup() {
    const { tagText, phone } = useWhatsappUrl()
    return { tagText, phone }
  },
  methods: {
    send(tagText, phone) {
      const text = encodeURIComponent(`${tagText}Olá, Gostaria de antecipar meu saldo de FGTS. Saldo FGTS: R$ ${this.$refs.currency.value}`)
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${text}&app=facebook&entry_point=page_cta`
      trackTiktokEvent('Contact')
      window.open(whatsappUrl, "_blank");
      this.amount = "";
      return false;
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $("#currency").maskMoney();
  },
};
</script>
